import { IxListItem } from './IxListItem.js';

window.customElements.define('ix-list-item', IxListItem);
